import { memoize, groupBy, filter, includes } from 'lodash';

export const filterAndGroupAppliances = memoize((categoryId, fields) => groupBy(
  filter(fields, ({ categories }) => includes(categories, categoryId)),
  'group',
));

export default filterAndGroupAppliances;



// WEBPACK FOOTER //
// ./src/views/Home/components/helpers/filterAndGroupAppliances.js